import React, { type FC, type PropsWithChildren } from 'react';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	useCurrentPriority,
	useIsNonCriticalStalled,
	loadingPriority,
} from './PriorityManager.tsx';

const BackgroundPriorityOld: FC<PropsWithChildren<{ forceRender?: boolean }>> = ({
	children,
	forceRender,
}) => {
	const tier = useCurrentPriority();
	if (!forceRender && tier < loadingPriority.background) {
		return null;
	}
	return <>{children}</>;
};
const BackgroundPriorityNew: FC<PropsWithChildren<{ forceRender?: boolean }>> = ({
	children,
	forceRender,
}) => {
	const tier = useCurrentPriority();
	const isNonCriticalStalled = useIsNonCriticalStalled();
	if (!forceRender && tier < loadingPriority.background && !isNonCriticalStalled) {
		return null;
	}
	return <>{children}</>;
};
export const BackgroundPriority = componentWithCondition(
	() => fg('jfp-magma-fix-hydration-completion'),
	BackgroundPriorityNew,
	BackgroundPriorityOld,
);

export const renderInBackgroundPriority = (Component: FC, bypassCondition?: () => boolean): FC => {
	const wrappedComponent = () => (
		<BackgroundPriority forceRender={bypassCondition ? bypassCondition() : false}>
			<Component />
		</BackgroundPriority>
	);
	wrappedComponent.displayName = `BackgroundPriority(${Component.displayName || Component.name})`;
	return wrappedComponent;
};
